import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useDashboardShell } from "./DashboardLayout";
import { formatCount } from "../Pages/Home/useAnimatedCount";

const DashboardTopbar = ({ title, tokenBalance, children }) => {
  const { t } = useTranslation("common");
  const { toggleSidebar } = useDashboardShell();

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button type="button" className="menu-toggle" onClick={toggleSidebar} aria-label="Menu">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <span className="topbar-title">{title}</span>
      </div>
      <div className="topbar-right">
        {tokenBalance != null && (
          <div className="topbar-badge">
            <span className="dot" />
            <span>
              {formatCount(tokenBalance)} {t("tokens")}
            </span>
          </div>
        )}
        {children}
      </div>
    </header>
  );
};

DashboardTopbar.propTypes = {
  title: PropTypes.string.isRequired,
  tokenBalance: PropTypes.number,
  children: PropTypes.node
};

DashboardTopbar.defaultProps = {
  tokenBalance: null,
  children: null
};

export default DashboardTopbar;
